































































































































import Vue from "vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import draggable from "vuedraggable";
import "@/assets/styles/package/vue-ctk-date-time-picker.css";
import graphqlQuery from "@/service/Api";
import { getIsoOffsetDate } from "@/helpers";
export default Vue.extend({
  components: {
    draggable,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      date: {
        start: "1984-09-04",
        end: "",
      },
      asc: false,
      bestUnit: [] as any,
      isLoading: true,
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    graphqlQuery,
    toggleSort() {
      if (this.asc === true) {
        this.bestUnit.sort(
          (a: any, b: any) => b.averageAnswer - a.averageAnswer,
        );
        this.asc = false;
      } else {
        this.bestUnit.sort(
          (a: any, b: any) => a.averageAnswer - b.averageAnswer,
        );
        this.asc = true;
      }
    },
    async getBestUnit() {
      this.isLoading = true;
      const query = `
        query {
          getBestUnit(limit: 10000,range: { from: "${this.date.start}", to: "${this.date.end}" }) {
            count
            averageAnswer
            unit {
              _id
              name
            }
          }
        }
      `;
      await this.graphqlQuery({ query }).then((res) => {
        const data = res.data.getBestUnit;
        if (data.length > 0) {
          this.bestUnit = res.data.getBestUnit.map((item: any, i: number) => {
            console.log("ites", item);
            return { ...item, id: i };
          });
        }
      });
      this.isLoading = false;
    },
    async sendRequest() {
      if (this.date.end) {
        await this.getBestUnit();
      }
    },
  },
  async mounted() {
    this.date.end = getIsoOffsetDate({ offset: 0 });
    await this.getBestUnit();
  },
});
